// Arabic clamav-stream strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enClamav } from './en-clamav.ts';
import type { Message } from './types.ts';

export const arClamav: { readonly [K in keyof typeof enClamav]: Message } = {
  'malware.v.rejected': 'رُفض الملف في فحص البرمجيات الضارة. حمِّل ملفًا آخر.',
  'malware.v.notChecked': 'تعذّر فحص الملف بحثًا عن البرمجيات الضارة الآن، لذلك لم يُستخدم. حاوِل لاحقًا.',
  'malware.api.notServable': 'لا يمكن فتح هذا الملف لأنه لم يجتز فحص البرمجيات الضارة.',
  'malware.api.notChecked': 'لم يجتز هذا الملف فحص البرمجيات الضارة، لذلك لا يمكن مراجعة محتواه. سجِّل بدلًا من ذلك أصلًا شوهد شخصيًا، أو افحص الملف مرة أخرى.',
  'malware.api.noScanner': 'لم يُضبط أي فاحص للبرمجيات الضارة.',
  'malware.api.notRescannable': 'لا يمكن فحص هذا الملف مرة أخرى: نتيجة فحصه نهائية، أو لم يعد الملف متاحًا.',
  'malware.prereg.rejected': 'رُفض هذا الملف في فحص البرمجيات الضارة. يُرجى تحميل ملف آخر.',
  'malware.prereg.notChecked': 'استُلم الملف، لكن تعذّر فحصه حتى الآن. يمكنك تحميله مرة أخرى، أو سيساعدك موظفو الاستقبال عند وصولك.',
  'malware.doc.status.not_scanned': 'لم يُفحص بحثًا عن البرمجيات الضارة',
  'malware.doc.status.clean': 'اجتاز فحص البرمجيات الضارة',
  'malware.doc.status.infected': 'رُفض في فحص البرمجيات الضارة',
  'malware.doc.status.failed': 'لم يكتمل فحص البرمجيات الضارة',
  'malware.doc.blocked': 'لا يمكن فتح الملف قبل اجتياز فحص البرمجيات الضارة. لا يزال بإمكانك تسجيل أصل شوهد شخصيًا.',
  'malware.doc.rescan': 'افحص مرة أخرى',
  'malware.doc.checkedAt': 'فُحص {time}',
  'malware.ctr.scannerOn': 'تُفحص الملفات المحمّلة بحثًا عن البرمجيات الضارة قبل أن يتمكن أي شخص من فتحها أو قبولها. ويمكن للمراجعين أيضًا قبول مستند أصلي رأوه شخصيًا.',
  'malware.ctr.rejected': 'رُفض الملف في فحص البرمجيات الضارة. اطلب ملفًا بديلًا، أو سجِّل أصلًا شوهد شخصيًا.',
  'malware.ctr.failed': 'تعذّر فحص الملف بحثًا عن البرمجيات الضارة حتى الآن. افحصه مرة أخرى، أو سجِّل أصلًا شوهد شخصيًا.',
  'malware.ctr.pending': 'لم يُفحص هذا الملف بحثًا عن البرمجيات الضارة بعد.',
  'malware.ctr.rescan': 'افحص مرة أخرى',
  'malware.ops.title': 'فاحص البرمجيات الضارة',
  'malware.ops.status.not_configured': 'غير مضبوط',
  'malware.ops.status.ok': 'متاح',
  'malware.ops.status.unavailable': 'غير متاح',
  'malware.ops.notConfigured': 'لا يمكن فحص الملفات المحمّلة، لذلك لا تُقبل الملفات إلا كأصل شوهد شخصيًا.',
  'malware.ops.unavailable': 'تبقى الملفات الجديدة دون فحص، ولا يمكن فتحها أو قبولها حتى يستجيب الفاحص مجددًا.',
  'malware.ops.engine': '{engine} · التواقيع {version} بتاريخ {date}',
  'malware.ops.age': { zero: 'عمر التواقيع أقل من يوم.', one: 'عمر التواقيع يوم واحد.', two: 'عمر التواقيع يومان.', few: 'عمر التواقيع {count} أيام.', many: 'عمر التواقيع {count} يومًا.', other: 'عمر التواقيع {count} يوم.' },
  'malware.ops.stale': 'التواقيع أقدم من {max} أيام: التحديثات لا تصل. تحقّق من وصول الفاحص إلى مرايا تحديث ClamAV.',
  'malware.ops.ageUnknown': 'تاريخ التواقيع غير معروف.',
};
